module.exports = __webpack_public_path__ + "./docs/img/big-icon-api_method.2662945893f41591d90498a00f5957f3.svg";